module.exports = __webpack_public_path__ + "img/spoc_bg.14a37cbb.jpg";